import { PaymentOrderEntityModel } from "src/store/models/entity/payment/order/entity";
import { PaymentOrderHelperModel } from "src/store/models/entity/payment/order/helper";

export const encooPaymentOrderModels = {
  entity: PaymentOrderEntityModel,
  helper: PaymentOrderHelperModel,
};
